import { lazy } from "react";

export const WorkspaceMembersView = lazy(
  () => import("./WorkspaceMembersView"),
);
